import sdk from 'redcatSdk'
import axios from '@/plugins/axios'
import { UUID } from '@/plugins/common'
import router from '@/router/index.js'
// import { tbhReportFn, tbhFormFn } from '../../components/custom/page/tbh/tbhFn'
import Vue from 'vue'

const vue = new Vue()

const Fn = Function

const reportCustomFn = {
  // 合同录入(提高加载速度，迁移到平台项目)
  '16976724-9E10-1C7C-5448-EEB46F5608C0': ({ eventBus, report, reportService, el }) => {
    let canClick = true
    // 隐藏三个筛选条件
    report.filters.forEach(obj => {
      if (obj.name === '开始时间' || obj.name === '截止时间' || obj.name === '分公司标识') {
        el.$set(obj, 'hidden', true)
      }
    })
    let currentUserInfo = ''
    let departmentId = ''
    eventBus.$on('report.onSearch', async (component) => {
      if (!component.param.filters['1697B1A4-3810-0615-DCB1-E01611E87978']) {
        if (!currentUserInfo || !departmentId) {
          currentUserInfo = await axios.get('/auth-api/oauth/currentUserInfo')

          let foundDepartment
          let departmentTransform = {
            // 京翼运营本部
            '000FB09B-0000-0000-0000-0000C2D5E918': [
              '0012DD26-0000-0000-0000-000018B279FD',
              '001132A2-0000-0003-0000-0000FDAF2BB5',
              '000F0888-0000-0000-0000-00007F77994D',
              '0005310D-0000-0000-0000-00006CEE18F8',
              '00050676-0000-0003-0000-0000283864EE',
              '0004AA0F-0000-0000-0000-0000BBC34F88',
              '000468DC-0000-0000-0000-0000730E8560'
            ],
            // 西安分公司
            '001132A2-0000-0008-0000-0000FDAFFFDF': [
              // 榆林地区
              '00112696-0000-0000-0000-000064E07682'
            ],
            // 青岛分公司
            '000AD838-0000-0001-0000-0000AE666F77': [
              // 临沂分公司
              '000F3AE3-0000-0000-0000-0000F9819B59'
            ]
          }
          for (const key in departmentTransform) {
            const departments = departmentTransform[key]
            if (departments.includes(currentUserInfo.data.departmentId)) {
              foundDepartment = key
            }
          }

          departmentId = foundDepartment || currentUserInfo.data.departmentId
        }
        let date = new Date()
        let year = date.getFullYear()
        let month = date.getMonth() + 1
        let day = date.getDate()
        if (month < 10) { month = '0' + month }
        if (day < 10) { day = '0' + day }
        let today = `${year}-${month}-${day}`
        el.$set(component.param.filters, '16C220A3-4580-02C9-E429-E0D58F2CD86F', today)
        el.$set(component.param.filters, '16C220A3-F380-02CB-6459-625FBA7E0ADF', today)
        el.$set(component.param.filters, '16C27E46-B230-04FF-0CCB-27E66F3D1B8E', departmentId)
      } else {
        el.$set(component.param.filters, '16C220A3-4580-02C9-E429-E0D58F2CD86F', '')
        el.$set(component.param.filters, '16C220A3-F380-02CB-6459-625FBA7E0ADF', '')
        el.$set(component.param.filters, '16C27E46-B230-04FF-0CCB-27E66F3D1B8E', '')
      }
    })
    eventBus.$on('report.onLoad', params => {
      if (params.id === report.id) {
        let button = el.report.buttons.find(n => n.id === '16A5245F-23B0-FD28-7BA4-0EE337303658')
        el.report.buttons.forEach(button => {
          vue.$set(button, 'getDisabled', ({ id, row, button }) => {
            let dataId = id || row.Id
            let flag1 = button.dataState && (button.dataState[dataId] === '3' || button.dataState[dataId] === '4')
            let flag2 = (button.HiddenState ? button.HiddenState[dataId] : false)
            let flag3
            let flag4 = (button.HiddenState2 ? button.HiddenState2[dataId] : false)
            let flag5
            if (button.id === '16A5245F-23B0-FD28-7BA4-0EE337303658') {
              if ('等待认证、等待基础认证、维修后再次认证'.indexOf(row['16A00B99-F5E0-A81F-A11C-1DD40792A8E1']) === -1
                || row['16A0692C-AC80-FFCC-EFD4-87D6920EC473'] === '已失效' || row['16A0692C-AC80-FFCC-EFD4-87D6920EC473'] === '已退单') {
                flag3 = true
              } else {
                flag3 = false
              }
            }
            if (button.id === '17321B63-2620-0140-4C44-BF5AA931EAC6') {
              if (row['17321B71-9450-0145-9609-7E1BFDEDA5EC'] === '鹏龙集团') {
                flag5 = false
              } else {
                flag5 = true
              }
            }
            return flag1 || flag2 || flag3 || flag4 || flag5
          })
        })

        vue.$set(button, 'getName', ({ id, row, button }) => {
          let dataId = id || row.Id
          if (button.dataState) {
            let name = ''
            switch (button.dataState[dataId]) {
              case '1':
                name = '认证申请'
                break
              case '2':
                name = '取消申请'
                break
              case '3':
                name = '已分配'
                break
              case '4':
                name = '认证申请'
                break
            }
            return name
          } else {
            return button.name
          }
        })
      }
    })

    eventBus.$on('report.buttonClick', async ({ button, dataId, row }) => {
      function print () {
        axios.get(`/huaao-api/contract/isBaseAuth/${dataId}`).then(async (res) => {
          axios.get(`/huaao-api/contract/getCheckGroupNameAndProductByOrOtherGroupName/${dataId}`).then(async (res1) => {
            if (res1.data !== '' && res1.data !== null) {
              if (res1.data.group_it === '祥龙博瑞集团') {
                await axios({
                  url: `/huaao-api/contract/printOther?id=${dataId}&modelId=17573D45-6790-0464-D308-2D6C176776C0&dataSources=合同录入`,
                  method: 'get',
                  responseType: 'blob'
                }).then(result => {
                  let blob = new Blob([result.data], { type: 'application/pdf' })
                  if (window.navigator.msSaveOrOpenBlob) {
                    window.open(window.location.protocol + '//' + window.location.host + ':' + window.location.port + `/huaao-api${process.env.NODE_ENV === 'production' ? '' : '/api'}/contract/printOther?id=${dataId}&modelId=17573D45-6790-0464-D308-2D6C176776C0&dataSources=合同录入`)
                  } else {
                    let objectUrl = window.URL.createObjectURL(blob)
                    window.open(objectUrl)
                  }
                })
              } else {
                await axios({
                  url: `/huaao-api/contract/printNew?id=${dataId}&type=1&secondType=contract&dataSources=合同录入`,
                  method: 'get',
                  responseType: 'blob'
                }).then(res => {
                  let blob = new Blob([res.data], {type: 'application/pdf'})
                  if (window.navigator.msSaveOrOpenBlob) {
                    window.open(window.location.protocol + '//' + window.location.host + ':' + window.location.port + `/huaao-api${process.env.NODE_ENV === 'production' ? '' : '/api'}/contract/printNew?id=${dataId}&type=1&secondType=contract&dataSources=合同录入`)
                  } else {
                    let objectUrl = window.URL.createObjectURL(blob)
                    window.open(objectUrl)
                  }
                })
                if (row['17321B71-9450-0145-9609-7E1BFDEDA5EC'] === '鹏龙集团') {
                  await axios({
                    url: `/huaao-api/contract/printOther?id=${dataId}&modelId=17230940-8E70-0089-B5E1-B5BF84AF8888&dataSources=合同录入`,
                    method: 'get',
                    responseType: 'blob'
                  }).then(result => {
                    let blob = new Blob([result.data], { type: 'application/pdf' })
                    if (window.navigator.msSaveOrOpenBlob) {
                      window.open(window.location.protocol + '//' + window.location.host + ':' + window.location.port + `/huaao-api${process.env.NODE_ENV === 'production' ? '' : '/api'}/contract/printOther?id=${dataId}&modelId=17230940-8E70-0089-B5E1-B5BF84AF8888&dataSources=合同录入&dataSources=合同录入`)
                    } else {
                      let objectUrl = window.URL.createObjectURL(blob)
                      window.open(objectUrl)
                    }
                  })
                }
              }
            } else {
              await axios({
                url: `/huaao-api/contract/printNew?id=${dataId}&type=1&secondType=contract&dataSources=合同录入`,
                method: 'get',
                responseType: 'blob'
              }).then(res => {
                let blob = new Blob([res.data], {type: 'application/pdf'})
                if (window.navigator.msSaveOrOpenBlob) {
                  window.open(window.location.protocol + '//' + window.location.host + ':' + window.location.port + `/huaao-api${process.env.NODE_ENV === 'production' ? '' : '/api'}/contract/printNew?id=${dataId}&type=1&secondType=contract&dataSources=合同录入`)
                } else {
                  let objectUrl = window.URL.createObjectURL(blob)
                  window.open(objectUrl)
                }
              })
              if (row['17321B71-9450-0145-9609-7E1BFDEDA5EC'] === '鹏龙集团') {
                await axios({
                  url: `/huaao-api/contract/printOther?id=${dataId}&modelId=17230940-8E70-0089-B5E1-B5BF84AF8888&dataSources=合同录入`,
                  method: 'get',
                  responseType: 'blob'
                }).then(result => {
                  let blob = new Blob([result.data], { type: 'application/pdf' })
                  if (window.navigator.msSaveOrOpenBlob) {
                    window.open(window.location.protocol + '//' + window.location.host + ':' + window.location.port + `/huaao-api${process.env.NODE_ENV === 'production' ? '' : '/api'}/contract/printOther?id=${dataId}&modelId=17230940-8E70-0089-B5E1-B5BF84AF8888&dataSources=合同录入`)
                  } else {
                    let objectUrl = window.URL.createObjectURL(blob)
                    window.open(objectUrl)
                  }
                })
              }
            }
          })
          let onejian = false
          await axios.get(`/form-api/runtime/getValueByParameter`, {
            params: {
              tableId: '16975C48-AB50-6622-25D1-F708D9D51DF7',
              columnId: '169E140E-D7B0-00E8-0D8F-67A0D1FBA650',
              parameter: {
                '16975C48-AB91-67A0-F8F4-499BB40251C5': row.Id
              }
            }
          }).then(res => {
            if (res.data === '一鉴安心') {
              onejian = true
            }
          })
          if (onejian) {
            return
          }
          // 如果 是否免验 为 是 的话，需要打印第二张合同
          if (res.data.state || row['170EB8BA-7330-0092-8CAD-323129C2E1AF'] === '是') {
            let checkCarId = res.data.checkCarId
            await axios({
              url: `/huaao-api/contract/printNew?id=${checkCarId}&type=3&secondType=contract&contractId=${dataId}`,
              method: 'get',
              responseType: 'blob'
            }).then(result => {
              let blob = new Blob([result.data], { type: 'application/pdf' })
              if (window.navigator.msSaveOrOpenBlob) {
                window.open(window.location.protocol + '//' + window.location.host + ':' + window.location.port + `/huaao-api${process.env.NODE_ENV === 'production' ? '' : '/api'}/contract/printNew?id=${checkCarId}&type=3&secondType=contract&contractId=${dataId}`)
              } else {
                let objectUrl = window.URL.createObjectURL(blob)
                window.open(objectUrl)
              }
            })
          }
        })
      }

      // 预览
      if (button.id === '17A3CA69-45C0-1295-5321-5AD8051FC668') {
        if (row["17A3BB24-6770-0652-BC86-98C9F71ED56B"] !== "电子合同") {
          return vue.$message.error('此合同非电子合同无法使用打印功能!')
        }
        el.$refs.report.page.loading = true
        await axios({
          url: `/huaao-api/contract/printNew?id=${dataId}&type=9`,
          method: 'get',
          responseType: 'blob'
         }).then(result => {
           el.$refs.report.page.loading = false
           if (result.status === 200) {
            let blob = new Blob([result.data], { type: 'application/jpg' })
            let objectUrl = window.URL.createObjectURL(blob)
            el.customDialog.visible = true
            el.customDialog.path = 'electronic-contract'
            el.customDialog.url = objectUrl
            el.customDialog.type = '预览'
            el.customDialog.title = '预览'
           }
         }).catch((err)=> {
            el.$refs.report.page.loading = false
            return vue.$message.error(err)
         })
      }

      // 合同终止确认函
      else if (button.id === '17CCADFE-DC10-06D1-6667-FC6F6166B827') {
        if (row["17A3BB24-6770-0652-BC86-98C9F71ED56B"] !== "电子合同") {
         return vue.$message.error('此合同非电子合同无法使用合同终止确认函功能!')
        }
        if (row["17D0798B-D9A0-00BA-BE8F-E0222DF8B9D5"] === "退单退费已签章") {
          return vue.$message.error('此合同终止确认函已签章!')
        }
        // 检测电子合同是否存在待审核数据
        let params = {
          index: 1,
          size: 10,
          filters: {
            '17D042A7-3D90-00AB-9696-22DDCBC4D849': dataId
          }
        }
        axios.get('/report-api/report/data/17D042A0-BD50-00A1-8A33-9C00A41883B8/count', { params }).then(async (res) => {
          if(res.data > 0){
            return vue.$message.error('此合同存在待审核数据，请稍后重试!')
          } else {
            await axios.get(`/huaao-api/electronicContract/getElectronicSignatureStatusById/${dataId}`).then((res) =>{
              if(res.data === "退单退费已签章"){
                return vue.$message.error('此合同终止确认函已签章!')
              } else {
                // 获取电子合同审核通过数量
                params = {
                  index: 1,
                  size: 10,
                  filters: {
                    '17CE9164-7F30-01A0-5016-2DBAA9E12A78': dataId
                  }
                }
                axios.get(`/huaao-api/Signatory/payStatus/${dataId}`).then(() => {
                  axios.get('/report-api/report/data/17CE911B-7310-0165-C7CA-1D40F08F3F45', {params}).then((res) => {
                    if (res.data[0]["17CE9130-DB50-0177-7EC0-F9D8EF76FB99"] > 0) {
                      vue.$msgbox.confirm(`终止确认函退费金额为${row["17D224CF-BDD0-00B4-5C0A-9E4586EB26A6"]}元，打印合同终止确认函后，原电子合同将失效`, '', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        customClass: 'deleMessageBox-custom'
                      }).then(async () => {
                        await axios.post(`/huaao-api/Signatory/openChargeback/${dataId}/3`).then((res) => {
                          if (res.data.code !== null && res.data.code === 200) {
                            window.open(res.data.data)
                          } else {
                            return vue.$message.error('数据异常，请重试!')
                          }
                        })
                      })
                    } else {
                      return vue.$message.error('未签署电子合同或审批未通过，无需打印合同终止确认函!')
                    }
                  })
                })
              }
            })
          }
        })
      }

      // 电子签章
      if (button.id === '17A3CA7D-2250-1296-E685-5C6B2FE6AAC7') {
        if (row["17A3BB24-6770-0652-BC86-98C9F71ED56B"] !== "电子合同") {
          return vue.$message.error('此合同非电子合同无法使用打印功能!')
        } else {
          el.$refs.report.page.loading = true
          await axios({
            url: `/huaao-api/Signatory/open/${dataId}/0`,
            method: 'post',
           }).then(result => {
            el.$refs.report.page.loading = false
             if (result.data.code === 200) {
               window.open(result.data.data)
             } else {
              return vue.$message.error(result.data.message)
             }
           }).catch((err)=> {
              el.$refs.report.page.loading = false
              return vue.$message.error(err)
           })
        }
      }


      // 视频录制
      else if (button.id === '17D70148-F0E0-0223-8ACE-A88134391A0B') {
        //VideoTape
        reportService.openPublicDialog({
          visible: true,
          componentType: 'VideoTape',
          title: '视频录制',
          width: '600px',
          data: { dataId },
          buttons: [
            // { name: '保存', type: 'confirm' },
            { name: '关闭', type: 'cancel' }
          ]
        })
      }

      // 打印
      if (button.id === '16A20EFA-F8D0-A9E2-55BF-0C5BE508267C') {
        // 电子合同禁止打印
        if (row["17A3BB24-6770-0652-BC86-98C9F71ED56B"] === "电子合同") {
          return vue.$message.error('此合同非纸质合同无法使用打印功能!')
        }
        // 打印
        // 超过5天不能打印
        if ((new Date().getTime() - new Date(row['1697B19D-699A-6468-F189-AF601D6E2088']).getTime()) / 1000 > (24 * 60 * 60 * 5)) {
          return vue.$message.error('超出5天不能打印!')
        }
        if ((row['17321B71-9450-0145-9609-7E1BFDEDA5EC'] === '鹏龙集团' && row['176D6AC1-F100-010F-738F-4CBFF9443885'].indexOf('奔驰') !== -1) || (row['17321B71-9450-0145-9609-7E1BFDEDA5EC'] === '永达集团' && (new Date(row['1697B19D-699A-6468-F189-AF601D6E2088']).getTime()>=new Date('2023-04-01 00:00:00').getTime()))) {
          if(row['17321B71-9450-0145-9609-7E1BFDEDA5EC'] === '永达集团'){
            vue.$confirm('', '请及时进行视频录制！', {
              confirmButtonText: '确认',
              customClass: 'publishMessageBox',
              center: true
            }).then(() => {
              print()
            }).catch(() => {
            })
          } else{
            vue.$confirm('', '请及时前往工作台-华奥办公进行录音上传！', {
              confirmButtonText: '确认',
              customClass: 'publishMessageBox',
              center: true
            }).then(() => {
              print()
            }).catch(() => {
            })
          }
        }
        // else if (row['17321B71-9450-0145-9609-7E1BFDEDA5EC'] === '永达集团' && (new Date(row['1697B19D-699A-6468-F189-AF601D6E2088']).getTime()>=new Date('2023-04-01 00:00:00').getTime())){
        // axios.get(`/huaao-api/contract/getUploadTheRecording/${dataId}`).then( res => {
        //     if(res.data == 0){
        //       vue.$confirm('', '请及时前往工作台-华奥办公进行录音上传！', {
        //         confirmButtonText: '确认',
        //         customClass: 'publishMessageBox',
        //         center: true
        //       }).then(() => {
        //         return
        //       }).catch(() => {
        //       })
        //     }else {
        //       print()
        //     }
        //   })
        // }
        else {
          print()
        }
      } else if (button.id === '17321B63-2620-0140-4C44-BF5AA931EAC6') {
        // 超过5天不能打印
        if ((new Date().getTime() - new Date(row['1697B19D-699A-6468-F189-AF601D6E2088']).getTime()) / 1000 > (24 * 60 * 60 * 5)) {
          return vue.$message.error('超出5天不能打印!')
        }
        if (row['17321B71-9450-0145-9609-7E1BFDEDA5EC'] === '鹏龙集团') {
          await axios({
            url: `/huaao-api/contract/printOther?id=${dataId}&modelId=17230940-8E70-0089-B5E1-B5BF84AF8888&dataSources=合同录入`,
            method: 'get',
            responseType: 'blob'
          }).then(result => {
            let blob = new Blob([result.data], { type: 'application/pdf' })
            if (window.navigator.msSaveOrOpenBlob) {
              window.open(window.location.protocol + '//' + window.location.host + ':' + window.location.port + `/huaao-api${process.env.NODE_ENV === 'production' ? '' : '/api'}/contract/printOther?id=${dataId}&modelId=17230940-8E70-0089-B5E1-B5BF84AF8888&dataSources=合同录入`)
            } else {
              let objectUrl = window.URL.createObjectURL(blob)
              window.open(objectUrl)
            }
          })
        }
      } else if (button.id === '1719F8F6-4120-06F1-BFAE-336674B8D70A') {
        // 打印
        // 超过5天不能打印
        if ((new Date().getTime() - new Date(row['1697B19D-699A-6468-F189-AF601D6E2088']).getTime()) / 1000 > (24 * 60 * 60 * 5)) {
          return vue.$message.error('超出5天不能打印!')
        }
        axios.get(`/huaao-api/contract/isBaseAuth/${dataId}`).then(async (res) => {
          let onejian = false
          await axios.get(`/form-api/runtime/getValueByParameter`, {
            params: {
              tableId: '16975C48-AB50-6622-25D1-F708D9D51DF7',
              columnId: '169E140E-D7B0-00E8-0D8F-67A0D1FBA650',
              parameter: {
                '16975C48-AB91-67A0-F8F4-499BB40251C5': row.Id
              }
            }
          }).then(res => {
            if (res.data === '一鉴安心') {
              onejian = true
            }
          })
          if (onejian) {
            return
          }
          // 如果 是否免验 为 是 的话，需要打印第二张合同
          if (res.data.state || row['170EB8BA-7330-0092-8CAD-323129C2E1AF'] === '是') {
            let checkCarId = res.data.checkCarId
            await axios({
              url: `/huaao-api/contract/printNew?id=${checkCarId}&type=3&secondType=contract&contractId=${dataId}`,
              method: 'get',
              responseType: 'blob'
            }).then(result => {
              let blob = new Blob([result.data], { type: 'application/pdf' })
              if (window.navigator.msSaveOrOpenBlob) {
                window.open(window.location.protocol + '//' + window.location.host + ':' + window.location.port + `/huaao-api${process.env.NODE_ENV === 'production' ? '' : '/api'}/contract/printNew?id=${checkCarId}&type=3&secondType=contract&contractId=${dataId}`)
              } else {
                let objectUrl = window.URL.createObjectURL(blob)
                window.open(objectUrl)
              }
            })
          }
        })
      } else if (button.id === '16A5245F-23B0-FD28-7BA4-0EE337303658') {
        if (!canClick) {
          return
        }
        canClick = false
        // [认证申请][取消申请][已分配]
        let name = button.getName({ id: dataId, button })
        let str = `${row['1697B19D-6981-F057-AAC2-11C68A9FA0E8']}_${row['1697B19D-69CE-E827-D59B-178A8325B2DE']}`
        switch (name) {
          case '认证申请':
            let partnerId = '' // 合作商内容
            let address = []
            // 根据dataId查询合同录入表单数据里的合作商标识
            await axios.get(`/form-api/runtime/16975C48-AB51-3104-14E9-4D003B0D4433/loadData?dataId=${dataId}`)
              .then(res => {
                partnerId = res.data['16975C52-BCF0-5ACC-7EFB-59B567CC5497']
              })

            await axios.get(`/form-api/runtime/1696FC03-35F1-97DF-BCE1-458C05A384B9/loadData?dataId=${partnerId}`)
              .then(res => {
                address.push({
                  '16BBFCC0-5C40-0207-3DCC-07FCE5CFF457': '默认地址',
                  '16BBFCC0-B190-0209-EBA5-E2210E80580C': res.data['16970DE1-1390-4E9C-BDB2-17381CE743AE'], // 地址
                  '16BBFCCA-CDD0-020B-AE0C-05704257F0D1': res.data['16970BED-D0D0-5136-2999-748618A27BF5'] * 1, // 经度
                  '16BBFCCB-0AD0-020D-12CF-978C439A451C': res.data['16970BF4-DE40-B141-E4FB-8EEB7EF1A44F'] * 1 // 纬度
                })
              })

            await axios.get('/report-api/report/data/16BBFCB4-30A0-0203-4F0B-F49F1B5D0605', {
              params: {
                index: 1,
                size: 10,
                filters: { '16BBFCCC-EDC0-020F-D3AA-BE890871B6B4': partnerId }
              }
            })
              .then(res => {
                address = address.concat(res.data)
              })
            if (address.length >= 2) {
              canClick = true
              reportService.openPublicDialog({
                visible: true,
                componentType: 'select-task-address',
                title: '任务地点确认',
                width: '600px',
                data: { dataId, row, address, tip: `您确定提交${str}的认证申请吗？`, reportService },
                buttons: []
              })
            } else {
              canClick = true
              vue.$msgbox.confirm(`您确定提交${str}的认证申请吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                customClass: 'deleMessageBox-custom'
              })
                .then(() => {
                  axios.post('/huaao-api/contract/applyAuthentication', { id: dataId }).then(() => {
                    reportService.search()
                  })
                })
            }
            break
          case '取消申请':
            vue.$msgbox.confirm(`您确定要取消${str}的认证申请吗？`, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              customClass: 'deleMessageBox-custom'
            })
              .then(() => {
                canClick = true
                axios.delete('/huaao-api/checkcar/cancel', { params: { vipMark: dataId } }).then(() => {
                  reportService && reportService.search && reportService.search()
                })
              })
              .catch(() => { canClick = true })
            break
        }
      } else if (button.id === '16B069ED-8100-01F4-0043-F54CFDB63071') {
        // 单证导出
        reportService && reportService.openPublicDialog && reportService.openPublicDialog({
          visible: true,
          componentType: 'exportDocuments',
          title: '单证导出',
          width: '486px',
          buttons: [
            { name: '关闭', type: 'cancel' },
            { name: '导出', type: 'confirm' }
          ],
          closeWithClick: false,
          closeWithEsc: false
        })
      } else if (button.id === '16B069B4-0AC0-00B3-F8EA-21FE77182E3C') {
        // 单证上传（客户经理）按钮
        reportService.openPublicDialog({
          visible: true,
          componentType: 'danzheng-upload',
          title: `${row['1697B19D-6983-D09B-73F4-7836426270C1']} ${row['1697B19D-6981-F057-AAC2-11C68A9FA0E8']} 单证上传(客户经理)`,
          width: '600px',
          data: { dataId },
          buttons: [
            { name: '关闭', type: 'cancel' }
          ]
        })
      } else if (button.id === '16B017C8-9D00-0165-77BB-490F4BA6FF19') {
        // 合同附加信息
        router.push({ name: 'additional-information', params: { id: row.Id } })
      } else if (button.id === '16B02505-1A50-0110-CE18-2AA4D675AF4E') {
        // 打印其他
        // 超过5天不能打印
        if ((new Date().getTime() - new Date(row['1697B19D-699A-6468-F189-AF601D6E2088']).getTime()) / 1000 > (24 * 60 * 60 * 5)) {
          return vue.$message.error('超出5天不能打印!')
        }
        let list = []
        let params = { id: row.Id }
        await axios.get(`/huaao-api/contract/getContractPrintModel`, { params }).then(res => (list = res.data))
        reportService && reportService.openPublicDialog && reportService.openPublicDialog({
          visible: true,
          componentType: 'printOther',
          title: `${row['1697B19D-6983-D09B-73F4-7836426270C1']} ${row['1697B19D-69CE-E827-D59B-178A8325B2DE']} 其他合同打印`,
          width: '600px',
          buttons: [
            { name: '关闭', type: 'cancel' }
          ],
          closeWithClick: false,
          closeWithEsc: false,
          list: list,
          rowId: row.Id,
          dataSources:'合同录入'
        })
      } else if (button.id === '16B45473-CD10-01F1-6C19-05FFE297DE88') {
        // 合同变更
        let onejian = false
        await axios.get(`/form-api/runtime/getValueByParameter`, {
          params: {
            tableId: '16975C48-AB50-6622-25D1-F708D9D51DF7',
            columnId: '169E140E-D7B0-00E8-0D8F-67A0D1FBA650',
            parameter: {
              '16975C48-AB91-67A0-F8F4-499BB40251C5': row.Id
            }
          }
        }).then(res => {
          if (res.data === '一鉴安心') {
            onejian = true
          }
        })
        if (onejian && row['16A00B9D-B1B0-A769-6A77-0CDB0DA82251'] === '已缴费') {
          return vue.$message.error('一鉴安心合同不可变更')
        }
        await axios.get('/huaao-api/contract/canChangeContract', { params: { dataId } }).then(() => {
          el.formRuntimeDialog.title = '变更'
          el.formRuntimeDialog.dataId = dataId
          el.formRuntimeDialog.type = 'form'
          el.formRuntimeDialog.id = '16975C48-AB40-3C2C-E229-A7B7B22A4C9F'
          axios.get('/form-api/defines/' + el.formRuntimeDialog.id)
            .then(res => {
              el.formRuntimeDialog.width = JSON.parse(res.data.form.form.properties).formScreen
              el.formRuntimeDialog.visible = true
              el.formRuntimeDialog.formValidates = res.data.form.form.formValidates && res.data.form.form.formValidates.filter(n => n.operationType.includes('update') && n.enable)
            })
        })
      } else if (button.id === '16B45478-6890-01F2-EAD4-0D35143B7EC9') {
        // 打印变更合同
        if (['延期打印', '打印变更'].some(n => n === row['16B554C8-0350-0105-DE79-5E7C278F85DF'])) {
          reportService.openPublicDialog({
            visible: true,
            componentType: 'print-change-contract',
            title: '打印变更合同',
            width: '600px',
            data: {dataId, row, type: 1, typeName: '合同'},
            buttons: [
              { name: '取消', type: 'cancel' },
              { name: '确定', type: 'confirm' },
            ]
          })
        } else {
          vue.$message.error('无延期审批通过数据！')
        }
      } else if (button.id === '16B92D98-56D0-016F-1999-542B3A349152') {
        // 电子合同禁止单证号变更
        if (row["17A3BB24-6770-0652-BC86-98C9F71ED56B"] === "电子合同") {
          return vue.$message.error('此合同非纸质合同无法使用单证号变更功能!')
        }
        let nowDate = new Date().toDateString()
        if (nowDate === new Date(row['1697B19D-699A-6468-F189-AF601D6E2088']).toDateString() && row['16A00B9D-B1B0-A769-6A77-0CDB0DA82251'] === '等待缴费') {
          return vue.$message.error('当天录入的未缴费合同不可发起变更')
        }
        reportService.openPublicDialog({
          visible: true,
          componentType: 'change-document',
          title: '单证号变更',
          width: '600px',
          data: { row, dataId },
          buttons: [
            { name: '取消', type: 'cancel' },
            { name: '保存', type: 'confirm' }
          ]
        })
      }
    })

    eventBus.$on('report.onDataLoad', (data) => {
      if (data.reportId === '16976724-9E10-1C7C-5448-EEB46F5608C0') {
        let button = el.report.buttons.find(n => n.id === '16A5245F-23B0-FD28-7BA4-0EE337303658')
        let ids = []
        data.data.forEach(n => ids.push(n.Id))
        if (data.data.length < 1) {
          return
        }
        axios.post('/huaao-api/contract/checkContractState', ids).then((res) => {
          let dataState = {}
          res.data.forEach(n => {
            dataState[n.id] = n.state
          })
          vue.$set(button, 'dataState', dataState)
        })

        axios.post('/huaao-api/contract/contractButtonHidden', ids)
          .then(res => {
            let HiddenState = {}
            res.data.forEach(n => {
              HiddenState[n.id] = n.hidden
            })
            el.report.buttons.forEach(button => {
              vue.$set(button, 'HiddenState', HiddenState)
            })
          })

        let HiddenState2 = {}
        data.data.forEach(row => {
          axios.get(`/huaao-api/contract/isBaseAuth/${row.Id}`).then(async (res) => {
            let onejian = false
            await axios.get(`/form-api/runtime/getValueByParameter`, {
              params: {
                tableId: '16975C48-AB50-6622-25D1-F708D9D51DF7',
                columnId: '169E140E-D7B0-00E8-0D8F-67A0D1FBA650',
                parameter: {
                  '16975C48-AB91-67A0-F8F4-499BB40251C5': row.Id
                }
              }
            }).then(res => {
              if (res.data === '一鉴安心') {
                onejian = true
              }
            })
            // 如果 是否免验 为 是 的话，需要打印第二张合同
            if ((res.data.state || row['170EB8BA-7330-0092-8CAD-323129C2E1AF'] === '是') && !onejian) {
              HiddenState2[row.Id] = false
            } else {
              HiddenState2[row.Id] = true
            }
          })
        })
        el.report.buttons.forEach(button => {
          if (button.id === '1719F8F6-4120-06F1-BFAE-336674B8D70A') {
            vue.$set(button, 'HiddenState2', HiddenState2)
          }
        })
      }
    })
  },
  '1690F749-9790-016C-B0D5-AB50109EF3D5': ({ eventBus }) => {
    // 处理按钮点击事件
    eventBus.$on('report.buttonClick', ({ button, dataId }) => {
      if (button.id === '1690F749-97A0-016D-8CE0-7F6335706917') {
        console.log(`当前点击的按钮是修改，可以执行接口修改数据。数据表示：${dataId}`)
      }
    })

    // 报表加载后附加一列
    const columnId = UUID.create()
    eventBus.$on('report.onLoad', (report) => {
      if (report) {
        const column = {
          id: columnId,
          name: '附加列',
          columnType: 'text',
          sort: 1,
          format: {}
        }
        report.columns.splice(1, 0, column)
      }
    })

    // 数据加载后生成数据
    eventBus.$on('report.onDataLoad', ({ data }) => {
      let rows = data
      rows.forEach((row) => {
        row[columnId] = `模拟值 ${Math.floor(Math.random() * 10)}`
      })
    })

    // 当搜索‘高’时，自动转换为 'gao'
    eventBus.$on('report.onSearch', (params) => {
      if (params.filters['1690F749-9A40-01A2-B3CA-DE8B99E49AE2'] === '高') {
        params.filters['1690F749-9A40-01A2-B3CA-DE8B99E49AE2'] = 'gao'
      }
    })
  },
  '1696FD1C-D2B0-C7A7-D358-6030A8D7EA51': ({ eventBus, reportService }) => {
    eventBus.$on('report.buttonClick', ({ button, dataId }) => {
      if (button.id === '1696FD6C-9F80-7330-A7E6-521D4072F9F9') {
        // 注销
        axios.get(`/cust-api/santai/cancelable/${dataId}`).then(res => {
          if (res.data) {
            vue.$confirm('', '您确认注销该投保吗?', {
              confirmButtonText: '是',
              cancelButtonText: '否',
              customClass: 'publishMessageBox',
              center: true
            }).then(() => {
              if (res.data) {
                axios.post(`/cust-api/santai/cancel/${dataId}`).then(() => {
                  reportService && reportService.search && reportService.search()
                })
              }
            }).catch(() => { })
          } else {
            vue.$message.error('已过注销截止时间，不能注销投保。')
          }
        })
      }
    })
  },
  '16A4A3F7-A710-6A92-C24E-F9E70E43E4E7': ({ eventBus, report, reportService, el }) => {
    // 教师销课
    eventBus.$on('report.buttonClick', ({ button, dataId, row }) => {
      if (button.id === '16A4A3F7-A712-5A69-8348-0F6B29E5C52A' || button.id === '16A4A3F7-A713-C4D2-7BDD-FEEF5CAE14AA') { // 销课 补销课
        sessionStorage.setItem('ac-course-date', row['16A4A3F9-B180-B404-52B1-337B074F7CAE'])
        sessionStorage.setItem('ac-course-time', row['16A4A3FB-A0A0-4E53-BEAA-CDC5B2FF85C5'])
        sessionStorage.setItem('ac-course-class', row['16A4A3FF-0D00-D8C1-638C-8BBA6C0DA3D0'])
        sessionStorage.setItem('ac-course-student-value', row['16A87900-33E0-7BDA-298A-A6B66202618C'])
        sessionStorage.setItem('ac-course-student-key', row['16A87903-54B0-E9E7-4D34-E4B68F233AB8'])
        sessionStorage.setItem('ac-course-id', row['16A914AD-3770-0CB9-B82E-6C8C6A392003'])
      }
    })
    eventBus.$on('report.onLoad', (report) => {
      if (report.id === '16A4A3F7-A710-6A92-C24E-F9E70E43E4E7') {
        let button = el.report.buttons.find(n => n.id === '16A4A3F7-A712-5A69-8348-0F6B29E5C52A')
        let button1 = el.report.buttons.find(n => n.id === '16A4A3F7-A713-C4D2-7BDD-FEEF5CAE14AA')
        vue.$set(button, 'getDisabled', ({ id, row, button }) => {
          let dataId = id || row.Id
          return button.dataState && (button.dataState[dataId] === '3' || button.dataState[dataId] === '4')
        })
        vue.$set(button1, 'getDisabled', ({ id, row, button }) => {
          let dataId = id || row.Id
          return button.dataState && (button.dataState[dataId] === '3' || button.dataState[dataId] === '4')
        })
      }
    })
    eventBus.$on('report.onDataLoad', (data) => {
      if (data.reportId === '16A4A3F7-A710-6A92-C24E-F9E70E43E4E7') {
        let button = el.report.buttons.find(n => n.id === '16A4A3F7-A712-5A69-8348-0F6B29E5C52A')
        let button1 = el.report.buttons.find(n => n.id === '16A4A3F7-A713-C4D2-7BDD-FEEF5CAE14AA')

        let ids = []
        data.data.forEach(n => ids.push(n.Id))
        let dataState = {}
        let dataState1 = {}
        data.data.forEach(n => {
          if (n['16A91F9C-2820-C410-EC7E-193FAB5F644C'] === '待销课') {
            dataState[n.Id] = '1'
            dataState1[n.Id] = '3'
          } else if (n['16A91F9C-2820-C410-EC7E-193FAB5F644C'] === '未销课') {
            dataState[n.Id] = '3'
            dataState1[n.Id] = '1'
          } else {
            dataState[n.Id] = '3'
            dataState1[n.Id] = '3'
          }
        })

        vue.$set(button, 'dataState', dataState)
        vue.$set(button1, 'dataState', dataState1)
      }
    })
  },
  // 培训学校-教师 查看排课
  '16A4A38A-3050-B7A8-3953-226BF21044B5': ({ eventBus, report, reportService, el }) => {
    eventBus.$on('report.buttonClick', ({ button, dataId }) => {
      if (button.id === '16A4EA1A-1B80-1F44-B81D-4209259139B7') {
        let params = {
          id: dataId
        }
        axios.get('/cust-api/aiChuang/students/downLoadTeachingPlan', { params }).then(res => {
          window.location.href = res.data
          throw new Error('中断操作')
        })
      }
    })
    eventBus.$on('report.onDataLoad', (data) => {
      if (data.reportId === '16A4A38A-3050-B7A8-3953-226BF21044B5') {
        axios.get('/cust-api/aiChuang/students/seeClass', data.params).then(res => {
          if (res.data.length !== 0) {
            let jsonData = res.data
            if (jsonData) {
              for (let i = data.data.length; i >= 0; i--) {
                data.data.pop()
              }
              jsonData.forEach(item => {
                data.data.push({
                  '16A4A38F-A780-2C89-C657-13C85AE8A3A7': item.date,
                  '16A4A391-C080-4308-4532-B9A1179E88B0': item.timeInterval,
                  '16A684F6-DA80-D87A-18AA-2B23847E09F5': item.curriculumLevel,
                  '16AAF566-64F0-00CF-C23A-39FD61774C68': item.curriculumName, // todo 切换环境id可能会变
                  '16A4A395-2BA0-1CD2-5E89-DFE4423EE87A': item.class,
                  '16A4A390-FA20-1BDB-5E10-0F13776C522B': item.weekDay,
                  'Id': item.id
                })
              })
            }
          } else {
            for (let i = data.data.length; i >= 0; i--) {
              data.data.pop()
            }
          }
        })
      }
    })
    eventBus.$on('report.onCountLoad', (data) => {
      if (data.reportId === '16A4A38A-3050-B7A8-3953-226BF21044B5') {
        axios.get('/cust-api/aiChuang/students/seeClass/count', { params: data.params }).then(res => {
          data.data.page.count = res.data
        })
      }
    })
  },
  '16A4A44B-A700-388D-7BEB-677DBD0AFCD7': ({ eventBus, report, reportService, el }) => {
    // 管理员补销课审批
    eventBus.$on('report.buttonClick', ({ button, dataId, row }) => {
      if (button.id === '16A4A457-31B0-39B9-1416-12A640F5BF35') { // 补销课审批
        sessionStorage.setItem('ac-course-date', row['16A4A44D-37F0-C924-79BD-C88606DCBB56'])
        sessionStorage.setItem('ac-course-time', row['16A4A44F-1160-5704-4C00-2ED749D4DA62'])
        sessionStorage.setItem('ac-course-class', row['16A4A454-D8C0-82EB-3F07-14F9D77C208D'])
        sessionStorage.setItem('ac-course-student-value', row['16A878F8-8E50-85C0-3143-A7FEC22179AE'] || '')
        sessionStorage.setItem('ac-course-reason', row['16A920E2-1F40-D764-E970-706CBFAF88D3'] || '')
        sessionStorage.setItem('ac-course-id', row['16A914A5-D2A0-CDA2-89A8-DE99B106756C'])
      }
    })
    eventBus.$on('report.onLoad', (report) => {
      if (report.id === '16A4A44B-A700-388D-7BEB-677DBD0AFCD7') {
        let button = el.report.buttons.find(n => n.id === '16A4A457-31B0-39B9-1416-12A640F5BF35')
        vue.$set(button, 'getDisabled', ({ id, row, button }) => {
          let dataId = id || row.Id
          return button.dataState && (button.dataState[dataId] === '3' || button.dataState[dataId] === '4')
        })
      }
    })
    eventBus.$on('report.onDataLoad', (data) => {
      if (data.reportId === '16A4A44B-A700-388D-7BEB-677DBD0AFCD7') {
        let button = el.report.buttons.find(n => n.id === '16A4A457-31B0-39B9-1416-12A640F5BF35')

        let ids = []
        data.data.forEach(n => ids.push(n.Id))
        let dataState = {}
        data.data.forEach(n => {
          if (n['16A91FA5-CB70-0B56-8800-F4C198A5E62A'] !== '超时待审批') {
            dataState[n.Id] = '3'
          }
        })

        vue.$set(button, 'dataState', dataState)
      }
    })
  },
  // 课程管理-课程体系
  '16A4A07C-F250-6B66-8BD8-E7D731E399A5': ({ eventBus, report, reportService, el }) => {
    // 导入前校验
    // todo 上生产之前 下载教案和删除按钮要更换id（更换后删除）
    eventBus.$on('report.beforeUpDataTemplate', async (params) => {
      if (params.tableId === '16A49FFB-EE80-2838-F136-54ECE05BD7D1') {
        let file = params.param.file
        let fd = new FormData()
        fd.append('file', file)
        await axios.post('/cust-api/aiChuang/students/validateCurriculumImport', fd).then(res => {
          if (res.data.message !== 0) {
            let errorString = ''
            res.data.errorList.forEach(item => {
              errorString += item + '、'
            })
            errorString = errorString.substr(0, errorString.length - 1)
            vue.$message.error('第 ' + errorString + ' 行中有错误,请修改后重新上传')
            throw new Error('中断操作')
          }
        })
      }
    })
    eventBus.$on('report.buttonClick', ({ button, dataId }) => {
      if (button.id === '16A4A07C-F261-48C7-D3A1-CDC67C225B39') {
        // 删除
        axios.delete(`/cust-api/aiChuang/students/delCurriculum/${dataId}`).then(res => {
          if (res.data === true) {
            let deleteId = el.$children[1].currentRow.Id
            el.$children[1].data.forEach((item, index) => {
              if (item.Id === deleteId) {
                el.$children[1].data.splice(index, 1)
                vue.$message.success('删除成功')
                throw new Error('不继续走')
              }
            })
          }
        })
      } else if (button.id === '16A9AA50-2070-A441-0A3E-74E50920283F') { // https://rc-test-test6353.ywsoftware.cn:9443环境下id
        let params = {
          id: dataId
        }
        axios.get('/cust-api/aiChuang/students/downLoadPlan', { params }).then(res => {
          window.location.href = res.data
          throw new Error('中断操作')
        })
      }
    })
  },
  // 培训学校-学员信息
  '16A4D348-0820-EF7A-C8C6-79CDEA04A560': ({ eventBus, report, reportService, el }) => {
    eventBus.$on('report.tampleDownload', async (tableId) => {
      if (tableId.tableId === '16A4A0A1-81B0-374B-8F78-45ED6D5CC9A4') {
        await axios({
          method: 'GET',
          url: '/cust-api/aiChuang/students/downStudentDataTemplate',
          responseType: 'blob'
        }).then(res => {
          let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
          let url = window.URL.createObjectURL(blob)
          let vDom = document.createElement('a')
          vDom.style.display = 'none'
          vDom.href = url
          vDom.setAttribute('download', '学员信息-模板下载.xls')
          document.body.appendChild(vDom)
          vDom.click()
          document.body.removeChild(vDom)
          window.URL.revokeObjectURL(url)
          throw new Error('不继续走')
        })
      }
    })
    eventBus.$on('report.beforeExport', async (params) => {
      if (params.reportId === '16A4D348-0820-EF7A-C8C6-79CDEA04A560') {
        // 导出
        await axios({
          method: 'GET',
          url: '/cust-api/aiChuang/students/exportStudentContract',
          responseType: 'blob'
        }).then(res => {
          let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
          let url = window.URL.createObjectURL(blob)
          let vDom = document.createElement('a')
          vDom.style.display = 'none'
          vDom.href = url
          vDom.setAttribute('download', '学员信息-导出.xls')
          document.body.appendChild(vDom)
          vDom.click()
          document.body.removeChild(vDom)
          window.URL.revokeObjectURL(url)
          throw new Error('不继续走')
        })
      }
    })
    eventBus.$on('report.onDataLoad', (data) => {
      if (data.reportId === '16A4D348-0820-EF7A-C8C6-79CDEA04A560') {
        data.params.filters = {
          name: data.params.filters['16A4D358-7630-2CA5-D24C-FB3D77390DF0'],
          level: data.params.filters['16A4D358-D2B0-D82E-D052-3499A6D62B82']
        }
        axios.get('/cust-api/aiChuang/students/findAll', { params: data.params }).then(res => {
          if (res.data.length !== 0) {
            let jsonData = res.data
            for (let i = data.data.length; i >= 0; i--) {
              data.data.pop()
            }
            jsonData.forEach(item => {
              data.data.push({
                '16A4D34E-F590-521E-7C7E-702338C29AD3': item.code,
                '16A4D34F-A410-1A50-D845-A06956A18DA8': item.name,
                '16A4D34F-FD10-FA94-6885-1D05576DD251': item.age,
                '16A4D350-B110-832A-BCC1-842922652CC2': item.currentLevel,
                '16A4D351-E010-953D-E394-E093EC8DEB07': item.currentHours,
                '16A4D37C-1090-1562-2F2D-66488C86E8C1': item.id,
                'Id': item.id
              })
            })
          } else {
            for (let i = data.data.length; i >= 0; i--) {
              data.data.pop()
            }
          }
        })
      }
    })
    eventBus.$on('report.beforeUpDataTemplate', async (params) => {
      if (params.tableId === '16A4A0A1-81B0-374B-8F78-45ED6D5CC9A4') {
        let file = params.param.file
        let fd = new FormData()
        fd.append('file', file)
        await axios.post('/cust-api/aiChuang/students/importStudentContract', fd).then(res => {
          if (res.data.message !== 0) {
            let errorString = ''
            res.data.errorList.forEach(item => {
              errorString += item + '、'
            })
            errorString = errorString.substr(0, errorString.length - 1)
            vue.$message.error('第 ' + errorString + ' 行中有错误,请修改后重新上传')
            throw new Error('第' + errorString + '行有错误')
          } else {
            vue.$message.success('导入成功')
            throw new Error('中断操作')
          }
        })
      }
    })
  },
  // 教务主管排课
  '16A4A304-ACA0-2729-6470-ADCA4BE8B2BB': ({ eventBus, report, reportService, el }) => {
    eventBus.$on('report.onLoad', (report) => {
      if (report.id === '16A4A304-ACA0-2729-6470-ADCA4BE8B2BB') {
        let button = el.report.buttons.find(n => n.id === '16A4A304-ACA3-199D-7956-1353961F92BA')
        let button1 = el.report.buttons.find(n => n.id === '16A4A313-BE00-D8AC-DFE4-6783C469B500')
        vue.$set(button, 'getDisabled', ({ id, row, button }) => {
          let dataId = id || row.Id
          return button.dataState && (button.dataState[dataId] === '3' || button.dataState[dataId] === '4')
        })
        vue.$set(button1, 'getDisabled', ({ id, row, button }) => {
          let dataId = id || row.Id
          return button.dataState && (button.dataState[dataId] === '3' || button.dataState[dataId] === '4')
        })
      }
    })
    eventBus.$on('report.onDataLoad', (data) => {
      if (data.reportId === '16A4A304-ACA0-2729-6470-ADCA4BE8B2BB') {
        let date = new Date()
        let seperator1 = '-'
        let year = date.getFullYear()
        let month = date.getMonth() + 1
        let strDate = date.getDate()
        if (month >= 1 && month <= 9) {
          month = '0' + month
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = '0' + strDate
        }
        let nowDate = new Date(year + seperator1 + month + seperator1 + strDate)

        let button = el.report.buttons.find(n => n.id === '16A4A304-ACA3-199D-7956-1353961F92BA')
        let button1 = el.report.buttons.find(n => n.id === '16A4A313-BE00-D8AC-DFE4-6783C469B500')

        let ids = []
        data.data.forEach(n => ids.push(n.Id))
        let dataState = {}
        data.data.forEach(n => {
          let courseDate = new Date(n['16A4A30C-C0F0-949B-DC7F-696BEA108E89'])
          if (((nowDate - courseDate) / (1000 * 60 * 60 * 24)) >= -1) {
            dataState[n.Id] = '3'
          }
        })

        vue.$set(button, 'dataState', dataState)
        vue.$set(button1, 'dataState', dataState)
      }
    })
  },
  // 学员审批
  '16A68402-0450-56EA-A791-D83A57E277B9': ({ eventBus, report, reportService, el }) => {
    eventBus.$on('report.onLoad', (report) => {
      if (report.id === '16A68402-0450-56EA-A791-D83A57E277B9') {
        let button = el.report.buttons.find(n => n.id === '16A68435-8010-7857-0F75-399A042A7B16')
        vue.$set(button, 'getDisabled', ({ id, row, button }) => {
          let dataId = id || row.Id
          return button.dataState && (button.dataState[dataId] === '3' || button.dataState[dataId] === '4')
        })
      }
    })
    eventBus.$on('report.onDataLoad', (data) => {
      if (data.reportId === '16A68402-0450-56EA-A791-D83A57E277B9') {
        let button = el.report.buttons.find(n => n.id === '16A68435-8010-7857-0F75-399A042A7B16')
        let ids = []
        data.data.forEach(n => ids.push(n.Id))
        let dataState = {}
        data.data.forEach(n => {
          if (n['16A68434-2410-8DD1-3C7C-1093830FDCD7'] !== '未审批') {
            dataState[n.Id] = '3'
          }
        })
        vue.$set(button, 'dataState', dataState)
      }
    })
  },
  '16ABA283-DA20-0029-111E-88A3B7781F84': ({ eventBus }) => {
    // 标准方案
    eventBus.$on('report.buttonClick', ({ button, dataId, row }) => {
      if (button.id === '16ABA283-DA30-002A-922D-74783AE89196') {
        // 添加
        router.push({ name: 'standard-solution' })
      } else if (button.id === '16ABA283-DA30-002B-BAF9-5E8DBDE6264C') {
        // 编辑
        router.push({ name: 'standard-solution', query: { dataId: row.Id } })
      }
    })
  },
  // onecar 检测订单
  '16D67154-AA10-002F-EBAA-287B04804303': ({ eventBus, report, reportService, el }) => {
    eventBus.$on('report.buttonClick', ({ button, dataId, row }) => {
      if (button.id === '16D671EA-7300-0051-77C5-400655EF2D62') {
        // 添加账单
        reportService.openPublicDialog({
          visible: true,
          componentType: 'onecar-add-bill',
          title: '添加账单',
          width: '600px',
          data: { dataId },
          closeWithClick: false,
          buttons: [
            { name: '保存', type: 'confirm' },
            { name: '关闭', type: 'cancel' }
          ]
        })
      } else if (button.id === '16D671F8-EEF0-0053-8CCB-3DDA77C304AB') {
        // 中止
        vue.$confirm('', '确认中止该条检测订单？', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          customClass: 'publishMessageBox'
        }).then(() => {
          axios.get(`/cust-api/onecar/mgr/updateStatus?id=${dataId}&status=3`).then(() => {
            vue.$message.success('操作完成！')
            reportService.search()
          })
        }).catch(() => { })
      }
    })
  }
}

const formCustomFn = {
  '168F0160-E9B0-313E-D01B-E585DB4B0A46': ({ eventBus, form }) => {
    // 拦截表单提交事件，请求接口并阻止提交
    eventBus.$on('form.beforeSubmit', async () => {
      form.dataService.data['168F0165-14C0-1328-778E-D1318219E313'] = 'test2'

      await axios.get('/cust-api/test')

      throw new Error('中断提交')
    })
  },
  '1696FAE7-BFF0-B915-AABF-25DBE1015842': ({ eventBus, form }) => {
    eventBus.$on('form.initButton', () => {
      if (form.dataService.data['1696FB87-C130-ABC5-C59C-B5BC516C49EC'] === '已投保') {
        form.define.buttons.splice(0, 1)
      } else {
        let btn = {
          id: '169509D0-AF06-83B1-765F-02E28E169569',
          name: '投保',
          hidden: false,
          type: 'comfirm'
        }
        form.define.buttons.splice(0, 0, btn)
      }
    })

    eventBus.$on('form.buttonClick', async (button) => {
      if (button.id === '169509D0-AF06-83B1-765F-02E28E169569') {
        // 投保
        form.dataService.data['1696FB87-C130-ABC5-C59C-B5BC516C49EC'] = '已投保'
        let reg = window.location.search.substr(1).match(new RegExp('(^|&)' + 'dataid' + '=([^&]*)(&|$)', 'i'))
        let dataId = reg ? reg[2] : ''
        const params = {
          id: dataId,
          travel: form.dataService.data['1696FB86-F810-ED00-4A1E-4024FAA8CBBA'],
          policyHolder: form.dataService.data['1696FAF3-2030-6198-9C9E-3FF29626D2F2'],
          flightNum: form.dataService.data['1696FB86-7610-6382-B27C-910BD0F4AE87']
        }
        await axios.get(`/cust-api/santai/checkDuplication`, { params }).then(res => {
          if (!res.data) {
            vue.$message.error('不能多次投保同时间的一趟航班')
            throw new Error('不能多次投保同时间的一趟航班')
          }
        })
      } else if (button.id === '1696FAE7-C016-D935-2C64-568056F2284C') {
        // 确定
        form.dataService.data['1696FB87-C130-ABC5-C59C-B5BC516C49EC'] = '已保存未投保'
        let reg = window.location.search.substr(1).match(new RegExp('(^|&)' + 'dataid' + '=([^&]*)(&|$)', 'i'))
        let dataId = reg ? reg[2] : ''
        const params = {
          id: dataId,
          travel: form.dataService.data['1696FB86-F810-ED00-4A1E-4024FAA8CBBA'],
          policyHolder: form.dataService.data['1696FAF3-2030-6198-9C9E-3FF29626D2F2'],
          flightNum: form.dataService.data['1696FB86-7610-6382-B27C-910BD0F4AE87']
        }
        await axios.get(`/cust-api/santai/checkDuplication`, { params }).then(res => {
          if (!res.data) {
            vue.$message.error('不能多次投保同时间的一趟航班')
            throw new Error('不能多次投保同时间的一趟航班')
          }
        })
      }
    })

    eventBus.$on('component.update', ({ component, value }) => {
      if (component.id === '1696FAF3-2031-B3A4-301B-431C74AC7453') {
        // 投保险人证件号
        let idCardType = form.dataService.data['1696FAF5-1A20-64BC-FF10-45459380F7BB']
        if (idCardType === '身份证') {
          if (value.length === 15) {
            form.dataService.data['1696FB0E-8420-A25C-3ECE-A52AF758E9D2'] = `19${value.substr(6, 2)}-${value.substr(8, 2)}-${value.substr(10, 2)}`
          } else if (value.length === 18) {
            form.dataService.data['1696FB0E-8420-A25C-3ECE-A52AF758E9D2'] = `${value.substr(6, 4)}-${value.substr(10, 2)}-${value.substr(12, 2)}`
          }
        }
      } else if (component.id === '1696FB3C-F2E1-5A51-4D6F-92CDA46FDC3B') {
        // 被保险人证件号
        let idCardType = form.dataService.data['1696FB3C-5740-79F7-30C4-572A97DADCD2']
        if (idCardType === '身份证') {
          if (value.length === 15) {
            form.dataService.data['1696FB63-A610-0D48-42B8-830067C19F91'] = `19${value.substr(6, 2)}-${value.substr(8, 2)}-${value.substr(10, 2)}`
          } else if (value.length === 18) {
            form.dataService.data['1696FB63-A610-0D48-42B8-830067C19F91'] = `${value.substr(6, 4)}-${value.substr(10, 2)}-${value.substr(12, 2)}`
          }
        }
      }
    })
  },
  // 排课详情
  '16A4A2B3-FE30-5C75-A81F-C5F4FF79874D': ({ eventBus, form }) => {
    // 日期和星期联动
    eventBus.$on('component.update', ({ component, value }) => {
      if (component.archive.id === '16A4A2B5-3CF1-8EC3-D31A-C71279137A4F') {
        let week = new Date(value).getDay()
        if (week === 0) {
          week = '日'
        } else if (week === 1) {
          week = '一'
        } else if (week === 2) {
          week = '二'
        } else if (week === 3) {
          week = '三'
        } else if (week === 4) {
          week = '四'
        } else if (week === 5) {
          week = '五'
        } else if (week === 6) {
          week = '六'
        }
        form.dataService.data['16A4A2B7-CA50-3A82-CB19-66A0C7F5D24F'] = '周' + week
      }
    })
    eventBus.$on('form.afterSourceOptions', async (data) => {
      if (data.id === '16A4A2D1-DC11-AF77-0C64-B42029FE5AC9') {
        await axios.get('/cust-api/aichuang/getEffectiveStudents').then(res => {
          if (res.data.length !== 0) {
            data.el.options.length = 0
            for (let i in res.data) {
              data.el.options.push({
                id: res.data[i].id,
                value: res.data[i].studentName
              })
            }
          } else {
            data.el.options = []
          }
          throw new Error('中断')
        })
      } else if (data.id === '16A4A2CF-D9E1-802F-03C2-7A54B26D4240') {
        let params = {
          roleId: '16AAFB24-ECC0-0B74-9A0F-101EF35A7920'
        }
        await axios.get('/auth-api/roles/getAccountByRoleId', { params }).then(res => {
          if (res.data.length !== 0) {
            data.el.options.length = 0
            for (let i in res.data) {
              data.el.options.push({
                id: res.data[i].id,
                value: res.data[i].name
              })
            }
          } else {
            data.el.options = []
          }
          throw new Error('中断')
        })
      }
    })
  },
  // 添加学员
  '16A4A154-5BA0-77EF-FB4F-6991C902FA85': ({ eventBus, form }) => {
    eventBus.$on('form.beforeSubmit', async (params) => {
      let phone = params.el.dataService.data['16A672D8-25C0-237E-200F-A945BC5B546D']
      let startDate = new Date(params.el.dataService.data['16A672D8-25A0-A5E2-88C1-745ADB3326C6'])
      let endDate = new Date(params.el.dataService.data['16A672D8-2610-6D4B-F0DF-FC8878B42127'])
      let status = params.el.dataService.data['16A672D8-25B0-829F-FE7E-DE1409FEC4FB']
      if (!(/^1[3-9]\d{9}$/.test(phone))) {
        vue.$message.error('联系方式输入错误，请重新输入')
        throw new Error('不继续走')
      } else if ((endDate - startDate) / (1000 * 60 * 60 * 24) < 0) {
        vue.$message.error('课程结束日期不可小于开始日期')
        throw new Error('不继续走')
      } else if (status === '待修改') {
        params.el.dataService.data['16A672D8-25B0-829F-FE7E-DE1409FEC4FB'] = '未审批'
      }
    })
    eventBus.$on('component.init', async ({ component, el }) => {
      if (component.id === '16A4A165-A6F1-9E87-9EC2-22ECCEB33F6A') {
        if (el.$parent.dataService.data['16A672D8-25B0-829F-FE7E-DE1409FEC4FB'] === '通过') {
          component.properties.readonly = true
        } else {
          component.properties.readonly = false
        }
      }
    })
  },
  // 学员审批
  '16A4A86F-6F50-AF2B-6A9D-2D1081316210': ({ eventBus, form }) => {
    let id = form.dataService.data.id
    eventBus.$on('form.beforeSubmit', async (params) => {
      let flag = ''
      if (params.button.id === '16A4A86F-6F68-9147-7E16-1A1F2D08EC48') {
        flag = '1'
      } else if (params.button.id === '16A4A86F-6F69-77E1-88CD-210909B57D40') {
        flag = '0'
      }
      await axios.post('/cust-api/aiChuang/students/studentApproval', { 'id': id, 'flag': flag })
        .then(() => {
          router.go(-1)
          throw new Error('')
        }).catch(() => {
          throw new Error('')
        })
    })
  },
  // 教师销课-销课
  '16A876C4-42F0-CC89-3431-63253E3A7F27': ({ eventBus, form }) => {
    let date = sessionStorage.getItem('ac-course-date')
    let time = sessionStorage.getItem('ac-course-time')
    let cclass = sessionStorage.getItem('ac-course-class')
    let value = sessionStorage.getItem('ac-course-student-value')
    let notPresentStudents = sessionStorage.getItem('ac-course-student-key')
    let dataId = sessionStorage.getItem('ac-course-id')

    form.dataService.data['16A87702-BE80-E315-D157-15597B9AEA67'] = date
    form.dataService.data['16A8770A-B9C0-57A8-0CBA-27EF423C2F82'] = time
    form.dataService.data['16A8770C-FC70-6BD9-E5B4-E7227F0507BF'] = cclass

    eventBus.$on('form.afterSourceOptions', async (data) => {
      if (data.id === '16A8770E-6961-B139-BA78-59117CC2E8B7') {
        if (value) {
          let arrValue = value.split(',')
          let arrNotPresentStudents = notPresentStudents.split(',')
          data.el.options.length = 0
          for (let i in arrValue) {
            data.el.options.push({
              id: arrNotPresentStudents[i],
              value: arrValue[i]
            })
          }
        }
        throw new Error('中断')
      }
    })

    eventBus.$on('form.beforeSubmit', async (params) => {
      if (params.button.id === '16A876C4-4333-1F37-9B71-E627E22BA9B8') {
        let notPresentStudents = params.el.dataService.data['16A8770E-6960-B95F-2B81-D57D2F98B19E'] || ''
        let postdata = {
          // dataId(数据id)，bntType（按钮类型：销课/补销课），notPresentStudents（未到场学生id多个，","分割），applicationReason（申请理由）
          'dataId': dataId,
          'bntType': '销课',
          'notPresentStudents': notPresentStudents.replace(/\s/g, ''),
          'applicationReason': ''
        }
        await axios.post(`/cust-api/aichuang/teacherCancelCourse`, postdata).then(() => { })
      }
    })
  },
  // 教师销课-补销课
  '16A877D6-99D0-7770-313B-DF1B90A6D54A': ({ eventBus, form }) => {
    // for (let i in form.dataService.data) {
    //   form.dataService.data[i] = i
    // }
    let date = sessionStorage.getItem('ac-course-date')
    let time = sessionStorage.getItem('ac-course-time')
    let cclass = sessionStorage.getItem('ac-course-class')
    let value = sessionStorage.getItem('ac-course-student-value')
    let notPresentStudents = sessionStorage.getItem('ac-course-student-key')
    let dataId = sessionStorage.getItem('ac-course-id')

    form.dataService.data['16A877E0-77F0-3312-93FF-95954BA1A3F4'] = date
    form.dataService.data['16A877E0-CAE0-E64E-C205-059359F8E6A7'] = time
    form.dataService.data['16A877E1-14D0-1AF5-9150-70CB3453D28D'] = cclass

    eventBus.$on('form.afterSourceOptions', async (data) => {
      if (data.id === '16A877E2-3171-88EF-1E02-FF16837E7D55') {
        if (value) {
          let arrValue = value.split(',')
          let arrNotPresentStudents = notPresentStudents.split(',')
          data.el.options.length = 0
          for (let i in arrValue) {
            data.el.options.push({
              id: arrNotPresentStudents[i],
              value: arrValue[i]
            })
          }
        }
        throw new Error('中断')
      }
    })

    eventBus.$on('form.beforeSubmit', async (params) => {
      if (params.button.id === '16A877D6-99E4-5476-93EA-71970EAA06DC') {
        let applicationReason = form.dataService.data['16A877E2-7590-7E01-57E9-DF817605B40B']
        let notPresentStudents = params.el.dataService.data['16A877E2-3170-0F86-CEDD-7886D37ABC9A'] || ''
        let postdata = {
          // dataId(数据id)，bntType（按钮类型：销课/补销课），notPresentStudents（未到场学生id多个，","分割），applicationReason（申请理由）
          'dataId': dataId,
          'bntType': '补销课',
          'notPresentStudents': notPresentStudents.replace(/\s/g, ''),
          'applicationReason': applicationReason
        }
        await axios.post(`/cust-api/aichuang/teacherCancelCourse`, postdata).then(() => { })
      }
    })
  },
  // 销课：管理员审批
  '16A877FB-F560-CC79-A9E6-102E15275E0A': ({ eventBus, form }) => {
    let date = sessionStorage.getItem('ac-course-date')
    let time = sessionStorage.getItem('ac-course-time')
    let cclass = sessionStorage.getItem('ac-course-class')
    let value = sessionStorage.getItem('ac-course-student-value')
    let applicationReason = sessionStorage.getItem('ac-course-reason')
    let dataId = sessionStorage.getItem('ac-course-id')

    form.dataService.data['16A877FE-5900-8CB1-D397-1AEC0D1A59A3'] = date
    form.dataService.data['16A877FE-9430-6610-782D-F07BE959B8AD'] = time
    form.dataService.data['16A877FE-CEA0-DBF4-44F7-1F21B94E9A17'] = cclass
    form.dataService.data['16A8797A-9E30-287A-D8C7-0DCDCD066099'] = value
    form.dataService.data['16A87800-7AD0-A162-BB66-788CFD8B0D4F'] = applicationReason

    eventBus.$on('form.beforeSubmit', async (params) => {
      if (params.button.id === '16A877FB-F580-D202-93CA-071D2C5986FC' || params.button.id === '16A877FB-F581-6EC7-534D-A3B1466081C1') {
        let bntType = '不通过'
        if (params.button.id === '16A877FB-F580-D202-93CA-071D2C5986FC') {
          bntType = '通过'
        }
        let postdata = {
          // dataId(数据id)，bntType（按钮类型：通过/不通过）
          'dataId': dataId,
          'bntType': bntType
        }
        await axios.post(`/cust-api/aichuang/adminApprovalCourse`, postdata).then(() => { })
      }
    })
  },
  // onecar 检测订单 上传检测报告 确定
  '16D672EB-B7C0-00BC-CB2B-37C53A2CFC00': ({ eventBus, form, formService, el }) => {
    eventBus.$on('form.beforeSubmit', async ({ button }) => {
      if (button.id === '16D672EB-B7D0-00C9-FF29-BBBC64925A81') {
        if (form.dataService.data['16D476E0-CB70-00D6-469A-F00187CD8F61'] === 'undefined') {
          form.dataService.data['16D476E0-CB70-00D6-469A-F00187CD8F61'] = ''
        } else if (form.dataService.data['16D476E0-CB70-00D6-469A-F00187CD8F61']) {
          form.dataService.data['16D476E0-CB70-00D6-469A-F00187CD8F61'] = form.dataService.data['16D476E0-CB70-00D6-469A-F00187CD8F61'].replace('undefined$.$', '$.$')
        }
        if (form.dataService.data['16D476E0-CB70-00D6-469A-F00187CD8F61']) {
          // 走定制上传图片
          axios.post(`/cust-api/onecar/runtime/${form.define.form.id}/saveData`, form.dataService.data).then(() => {
            vue.$message.success('上传报告成功！')
          })
        } else {
          vue.$message.warning('请上传报告！')
          return Promise.reject(new Error(''))
        }
      }
    })
  }
}

const processCustomFn = {
  // 调店流程(提高加载速度，迁移到平台项目)
  '16AC4511-4480-2173-B824-BDF9BF8C5816': ({ eventBus, process, el }) => {
    if (process.currentNode !== undefined && process.currentNode.id === "_17A8A700-4F30-008B-EEF9-D88AD22AE14E") {
      process.currentNode.actions.pop()
    }
    eventBus.$on('process.beforeStartingProcess', async ({ params, currentNode }) => {
      if (currentNode.id === '_169F1B09-BE40-417E-811F-76FC766DA220') {
        // 发起节点(调店申请) - 判断当前合作商是否有培训时间
        let data = process.dataService.data['169F1B1F-5E04-C51B-B711-783705F51A11'].map(e => {
          return e['169F1B32-9080-A594-DD78-0870A577DCB4']
        })
        await axios.post('/huaao-api/partnerManage/getTrainStartTime', data).then(res => {
          let notAllowedPartner = []
          if (res.data.status === 1) {
            notAllowedPartner = res.data.list.filter(e => {
              return !e.trainStartTime
            })
          }
          // 如果存在无培训开始时间的合作商则提示用户,并禁止流程流转
          if (notAllowedPartner.length !== 0) {
            let partnerName = notAllowedPartner.map(e => { return e.partnerName }).join()
            el.$message.error(`${partnerName}无首次培训时间,不能进行调店操作,请发起培训流程或联系培训部!`)
            throw new Error('存在无首次培训时间合作商,流程不流转')
          }
        })
        // 测调店情况为“调入”的合作商，如果在驻店管理表中，（木有离店时间或离店时间大于“生效日期”）的人数大于5人则提示
        // 169F1B3F-EF70-80E4-B491-914B1CFE113C 调入  169F1B32-9080-A594-DD78-0870A577DCB4  合作商id  169F1B7C-9580-A92C-A664-597A6EC1662A date
        let mingxiList = process.dataService.data['169F1B1F-5E04-C51B-B711-783705F51A11']
        let list = []
        mingxiList.forEach((item) => {
          if (item['169F1B3F-EF70-80E4-B491-914B1CFE113C'] === '调入') {
            let obj = {}
            obj.partnerId = item['169F1B32-9080-A594-DD78-0870A577DCB4']
            obj.date = item['169F1B7C-9580-A92C-A664-597A6EC1662A']
            list.push(obj)
          }
        })
        await axios.post('/huaao-api/process/checkManagerNumber', list)
        await axios.post('/huaao-api/process/TransferInStatistics', mingxiList).then(res => {
          if(res.data === "0" || res.data === 0){
            process.dataService.data["17A98936-ADC0-00BE-242A-4EB0C71EACFA"] = 0
          }
        })
        if (process.dataService.data["17A98936-ADC0-00BE-242A-4EB0C71EACFA"] === 0) {
          // 如果驻店人数为0，则需要加载单证回收明细数据
          let filArr = process.dataService.data["169F1B1F-5E04-C51B-B711-783705F51A11"]
          let newFilArr = [];
          filArr.filter( (item,i) =>{
            if(item["169F1B32-9080-A594-DD78-0870A577DCB4"]){
              newFilArr.push(item["169F1B32-9080-A594-DD78-0870A577DCB4"])
            }
          })
          if (newFilArr.length > 0) {
            let params = { index: -1, size: 100, filters: { '17A8A84B-C120-00CC-076D-769AF382B5C9': newFilArr.toString().replace(",",", ") } }
            await axios.get('/report-api/report/data/17A8A842-F9C0-00B4-D195-0FD44304019F', {params}).then((res) => {
              process.dataService.data["17A8A727-7E80-00AD-A518-89917F677F55"] = []
              res.data.forEach((n,i) => {
                let info = {
                    id: UUID.create(),
                    '17A8A733-93F0-00B0-7832-9D827A3D5489': n['17A8A899-D0A0-00EB-E6A4-B7A322E42074'],
                    '17A8A72A-AA60-00AE-5033-C83589B73DFA': n['17A8A847-DBD0-00BA-ACC4-BFB2CC38E600'],
                    '17A8A735-06E0-00B2-3592-16BAAE1C2149': parseInt(n['17A8A871-AE60-00D6-6C53-31FB9995F606']) + 1,
                    '17A8A735-86B0-00B4-1730-627B7928BC71': n['17A8A849-1F80-00C2-D3A8-76297671430C'],
                }
                process.dataService.data["17A8A727-7E80-00AD-A518-89917F677F55"].push(info)
              })
            })
          }
        }
      }
    })
    eventBus.$on('process.beforeSubmit', async ({ params, currentNode }) => {
      if (currentNode.id === '_169F1BC0-B710-3675-CBA8-1D98A126A935') {
        // 总经理审批节点
        params.nodeId = currentNode.id
        if (params.actionId === '_169F1BC0-B712-F50E-0505-0B9BD90D4859') {
          await axios.post('/huaao-api/process/updateTiaoDianInfo', params)
        }
        await axios.post('/huaao-api/process/completeTask', params)
          .then(() => {
            if (params.actionId === '_169F1BC0-B712-F50E-0505-0B9BD90D4859') {
              axios.post('/huaao-api/process/sendEmailAfterChangeShop', params)
            }
            el.$emit('closeDialog', 'process')
            throw new Error('')
          })
      }
    })
    eventBus.$on('component.init', ({ component, el }) => {
      // 调店流程，单证回收节点，因为此节点自动流转，前端定制代码不运行，已将功能迁移至发起节点发起之前加载
      if (component.componentId === 'kqw3e2n8') {
        let filArr = el.dataService.data["169F1B1F-5E04-C51B-B711-783705F51A11"]
        let newFilArr = [];
        filArr.filter( (item,i) =>{
          if(item["169F1B32-9080-A594-DD78-0870A577DCB4"]){
            newFilArr.push(item["169F1B32-9080-A594-DD78-0870A577DCB4"])
          }
        })
        if (newFilArr.length > 0) {
          let params = { index: -1, size: 100, filters: { '17A8A84B-C120-00CC-076D-769AF382B5C9': newFilArr.toString().replace(",",", ") } }
            axios.get('/report-api/report/data/17A8A842-F9C0-00B4-D195-0FD44304019F', {params}).then((res) => {
              el.dataService.data["17A8A727-7E80-00AD-A518-89917F677F55"] = []
              res.data.forEach((n,i) => {
                let info = {
                    id: UUID.create(),
                    '17A8A733-93F0-00B0-7832-9D827A3D5489': n['17A8A899-D0A0-00EB-E6A4-B7A322E42074'],
                    '17A8A72A-AA60-00AE-5033-C83589B73DFA': n['17A8A847-DBD0-00BA-ACC4-BFB2CC38E600'],
                    '17A8A735-06E0-00B2-3592-16BAAE1C2149': parseInt(n['17A8A871-AE60-00D6-6C53-31FB9995F606']) + 1,
                    '17A8A735-86B0-00B4-1730-627B7928BC71': n['17A8A849-1F80-00C2-D3A8-76297671430C'],
                }
                el.dataService.data["17A8A727-7E80-00AD-A518-89917F677F55"].push(info)
              })
          })
        }
      }
      // 调店申请详细内容 - 生效日期控件
      if (component.componentId === '16AC4511-4550-2183-1FC2-86133F9BC623') {
        // 只能选今天及以后的日期
        let pickerOptions = {
          disabledDate (time) {
            return time.getTime() < Date.now() - 60 * 60 * 24 * 1000
          }
        }
        el.$set(component.properties, 'pickerOptions', pickerOptions)
      }
    })
  },
  // 单证发放(提高加载速度，迁移到平台项目)
  '16AC4496-42C0-1A88-6614-C60C03F6D791': ({ eventBus, process, el }) => {
    eventBus.$on('process.beforeSubmit', async ({ params, currentNode }) => {
      params.nodeId = currentNode.id
      let Status = "1"
      if (currentNode.id === '_169C856D-D740-5FC0-BF35-8859A7ED07CA' || currentNode.id === '_169C80FC-06F0-3B0D-5403-DB3E029E7772') {
        // _169C80FC-06F0-3B0D-5403-DB3E029E7772 业管行政节点
        // _169C856D-D740-5FC0-BF35-8859A7ED07CA 单证确认节点
        if (params.actionId === '_169C8590-2CE0-6AB3-FF32-67A3B19743FD' || params.actionId === '_169C80FC-06F2-C351-E6D4-88455BE53409') {
          // 点击的是确认按钮
          params.check = "check"
          if(params.variables["169FC8A2-8780-56C1-FD6D-D99FEF70ADB2"].length > 0){
             params.variables["169C879A-96F5-E239-0FCE-824F3BCE95D0"].filter(async item  =>  {
                if(item["169C87DB-E460-EEB4-68C6-E2E661D63FE4"] === "C" && item["169C8814-E350-5319-FD81-B1A9A329B0FA"] >= 994001 && new Date()  <= new Date("2023-06-01 00:00:00") && currentNode.id === '_169C856D-D740-5FC0-BF35-8859A7ED07CA'){
                  Status = "2"
                }
                if(item["169C87DB-E460-EEB4-68C6-E2E661D63FE4"] === "R" && item["169C8814-E350-5319-FD81-B1A9A329B0FA"] >= 916001 && new Date()  <= new Date("2023-06-01 00:00:00") && currentNode.id === '_169C856D-D740-5FC0-BF35-8859A7ED07CA'){
                  Status = "2"
                }
             })
          }
          if(Status === "2"){
            await el.$msgbox({
              title: '',
              message: '6月1日前不可绑定新版单证，请至6月1日再确认。如有问题请联系业管部！',
              showCancelButton: false,
              confirmButtonText: '确认',
              center: true
            }).then(() => {
              throw new Error('本按钮不流转流程')
            }).catch(() => {
              throw new Error('本按钮不流转流程')
            })
            throw new Error('')
          } else {
            await axios.post('/huaao-api/serial/docDistribute/run', params).then(async (res)=>{
              if (res.data.indexOf("您已不在该店") >=0) {
                await el.$msgbox({
                  title: res.data,
                  showCancelButton: true,
                  confirmButtonText: '确定',
                  cancelButtonText: '取消'
                }).then(() => {
                  delete params["check"]
                  axios.post('/huaao-api/serial/docDistribute/run', params)
                }).catch(() => {
                  throw new Error('本按钮不流转流程')
                })
              }
            })
          }
        }
      }
      if(Status == 1){
        await axios.post('/huaao-api/process/completeTask', params)
          .then(() => {
            el.$emit('closeDialog', 'process')
            throw new Error('')
          }).catch(() => {
            throw new Error('')
          })
      }
    })
  },
  // 督导派驻流程(提高加载速度，迁移到平台项目)
  '16AC453F-32C0-24FA-567B-7F683900DEDF': ({ eventBus, process, el }) => {
    eventBus.$on('component.init', ({ component }) => {
      if (component.componentId === '16AC453F-3450-253A-0722-828C17016C34') {
        if (process.currentNode.id === '_16A35213-3310-02CD-73A3-8C7BA0EC0EBB') {
          // // 出单件数
          // let times = []
          // process.dataService.data['16A42C4C-AAA1-9B8E-56F9-D310D76D324C'].forEach(e => times.push(e['16A42C50-6EC0-16BA-81DE-A3A459114B51']))
          // let params = {
          //   partner_id: process.dataService.data['16C41F24-01D0-00CB-8A30-BC332CB4CD3D'],
          //   except_date: times.join(','),
          //   startDate: process.dataService.data['16A34C1F-6390-A144-473C-8EEC9DA01BF9'],
          //   endDate: process.dataService.data['16A3522A-BDE0-A084-0C72-B24C81C27714']
          // }
          // if (params.except_date === '') {
          //   delete params.except_date
          // }
          // axios.post('/huaao-api/saleSupervision/getMyIssueCount', params).then(res => {
          //   process.dataService.data['16A42CC3-BEF0-80E1-9400-3CB875397646'] = res.data.data || 0
          //   process.dataService.data['16AD4661-BD10-0653-5609-F34E427FA38C'] = res.data.accountingSales // 核算销售额
          //   process.dataService.data['18DC054D-3D40-0953-BB68-CC383F446869'] = res.data.assessSalesRevenue // 考核销售额
          // })
        }
      } else if (component.componentId === '16AC453F-3400-252C-E16A-A6912E418DD9') {
        if (process.currentNode.id === '_16A34C3C-B670-540C-B727-468E6A082FDE') {
          let params = {
            applyPartnerId: process.dataService.data['16CFA1BB-9E90-00AF-4A5A-C690FC878282'],
            signPartnerId: process.dataService.data['16A34D0D-3B70-61FC-2982-595874C16B33']
          }
          axios.get(`/huaao-api/attendance/isOffsite`, { params }).then((res) => {
            if (res.data) {
              process.dataService.data['16AD45CB-7C00-009E-A1B8-1490A0B75688'] = '是'
            } else {
              process.dataService.data['16AD45CB-7C00-009E-A1B8-1490A0B75688'] = '否'
            }
          })
        }
      }
    })
    eventBus.$on('process.beforeSubmit', async ({ params, currentNode }) => {
      if (process.currentNode.id === '_16A34C3C-B670-540C-B727-468E6A082FDE') {
        // 出单件数
        let times = []
        process.dataService.data['16A42C4C-AAA1-9B8E-56F9-D310D76D324C'].forEach(e => times.push(e['16A42C50-6EC0-16BA-81DE-A3A459114B51']))
        let params = {
          partner_id: process.dataService.data['16C41F24-01D0-00CB-8A30-BC332CB4CD3D'],
          except_date: times.join(','),
          startDate: process.dataService.data['16A34C1F-6390-A144-473C-8EEC9DA01BF9'],
          endDate: process.dataService.data['16A3522A-BDE0-A084-0C72-B24C81C27714']
        }
        if (params.except_date === '') {
          delete params.except_date
        }
        await axios.post('/huaao-api/saleSupervision/getMyIssueCount', params).then(res => {
          process.dataService.data['18CD24F7-C4A0-0333-6D9A-BD8827A53CA0'] = res.data.isMiddleToSeniorAccountManagers // 是否存在中高级客户经理出单
          process.dataService.data['16A42CC3-BEF0-80E1-9400-3CB875397646'] = res.data.data || 0
          process.dataService.data['16AD4661-BD10-0653-5609-F34E427FA38C'] = res.data.accountingSales // 核算销售额
          process.dataService.data['18DC054D-3D40-0953-BB68-CC383F446869'] = res.data.assessSalesRevenue // 考核销售额
        })
        let params1 = {
          "starTime":process.dataService.data['16A34C1F-6390-A144-473C-8EEC9DA01BF9'],
          "endTime":process.dataService.data['16A3522A-BDE0-A084-0C72-B24C81C27714'],
          "supervisionId":process.dataService.data['16A34DA2-0370-A494-ABC9-A0E4B951D95A'],
          "partnerId":process.dataService.data['16C41F24-01D0-00CB-8A30-BC332CB4CD3D'],
          "id":process.dataService.data.id
        }
        await axios.post('/huaao-api/attendance/supervisionDeployment', params1).catch(()=>{
          message.error('系统异常，请稍后重试!')
          throw new Error('系统异常，请稍后重试!')
        })
      }
    })
    eventBus.$on('component.update', async ({ component, value }) => {
      // 查询未考勤历史
      if (component.componentId === '16AC453F-33E0-2522-1E24-33424E18E96F') {
        if (value) {
          let params = {
            startTime: process.dataService.data['16A34C1F-6390-A144-473C-8EEC9DA01BF9'],
            endTime: value,
            partnerId: process.dataService.data['16C41F24-01D0-00CB-8A30-BC332CB4CD3D']
          }
          await axios.get('/huaao-api/attendance/getSignHistory', { params }).then(res => {
            process.dataService.data['16A42C4C-AAA1-9B8E-56F9-D310D76D324C'] = []
            let dataArr = Object.keys(res.data)
            for (let i = 0; i < dataArr.length - 1; i++) {
              for (let j = 0; j < dataArr.length - 1 - i; j++) {
                if (new Date(dataArr[j]) > new Date(dataArr[j + 1])) {
                  let temp = dataArr[j]
                  dataArr[j] = dataArr[j + 1]
                  dataArr[j + 1] = temp
                }
              }
            }
            dataArr.forEach((n, index) => {
              process.dataService.data['16A42C4C-AAA1-9B8E-56F9-D310D76D324C'].push({
                '16A42C50-6EC0-16BA-81DE-A3A459114B51': n,
                '16A42C52-8400-6366-987B-700B15B33ABA': res.data[n],
                dataState: 'create',
                id: UUID.create(),
                index: index
              })
            })
            process.dataService.data['16A35230-AEF0-059F-8313-BEAEBACB22DD'] = (new Date(value) - new Date(process.dataService.data['16A34C1F-6390-A144-473C-8EEC9DA01BF9'])) / (24 * 60 * 60 * 1000) + 1 - dataArr.length
          })
        }
      }
    })
  },
}

class CodeService {
  code = ''
  context

  constructor (context) {
    this.context = {
      eventBus: context.eventBus
    }

    if (context.form) {
      this.context.form = context.form
      this.context.define = context.form.define
      if (context.formService) {
        this.context.formService = context.formService
      }
    } else if (context.report) {
      this.context.report = context.report
      this.context.define = context.report
      if (context.reportService) {
        this.context.reportService = context.reportService
      }
    } else if (context.process) {
      this.context.process = context.process
      this.context.define = context.process.define
    }

    if (context.reportServiceDep) {
      this.context.reportServiceDep = context.reportServiceDep
    }
    if (context.el) {
      this.context.el = context.el
    }

    let viewUrl = sessionStorage.getItem('ossDownloadUrl')
    if (viewUrl) {
      this.context.eventBus.sharedViewUrl = viewUrl
    } else {
      axios.get('/shared-api/files/oss').then(res => {
        this.context.eventBus.sharedViewUrl = res.data.host
      })
    }
  }

  load () {
    let fn, key

    // 热代码加载，并根据定义挂在代码
    if (this.code) {
      fn = new Fn('context', this.code)
    } else if (this.context.form) {
      key = this.context.form.define.id
      fn = formCustomFn[key]
    } else if (this.context.report) {
      key = this.context.report.id
      fn = reportCustomFn[key]
    } else if (this.context.process) {
      key = this.context.process.define.componentId
      fn = processCustomFn[key]
    }

    if (fn) {
      fn(this.context)
    }

    sdk.exts.functionManager.run(this.context)
  }
}

class EventBus {
  listeners = {}

  $on (event, callback) {
    if (!(callback instanceof Function)) {
      throw new Error('callback is not a function.')
    }

    if (!(event in this.listeners)) {
      this.listeners[event] = []
    }

    // 根据函数内容排重
    let index = this.listeners[event].map(n => n.toString()).indexOf(callback.toString())
    if (index === -1) {
      this.listeners[event].push(callback)
    } else {
      this.listeners[event][index] = callback
    }
  }

  $emit (event, args) {
    if (!(event in this.listeners)) {
      return
    }
    const promises = []
    for (const stack of this.listeners[event]) {
      promises.push(stack.call(this, args))
    }
    return Promise.all(promises)
  }
}

export default CodeService
export { EventBus }



// WEBPACK FOOTER //
// ./src/store/form-runtime/codeService.js